import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardActions,
  Dialog,
  Button,
  FormControl,
  InputLabel,
  Input,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from '@material-ui/icons/Add';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "./../../../store/actions";
import * as paths from "./../../../Routes/paths";
import Comment from "./Comment";
import Loading from "./../Loading";
import Product from "./Product";

const styles = makeStyles((theme) => ({
  contentWrapper: {
    margin: '40px 16px',
  },
  button: {
      margin: theme.spacing(1),
    },
}))

const GetProducts = () => {
  const [productData, setproductData] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const dispatch = useDispatch();
  const { request, products, error } = useSelector((state: any) => {
    return state;
  });
  const classes = styles();
  useEffect(() => {
    setproductData(products);
    setSearchResults(products);
  }, [products]);

  useEffect(() => {
    dispatch(getProducts());
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const searchequestChange = (e) => {
    setSearchTerm(e.target.value);
  }

  useEffect(() => {
    const results = productData.filter(item =>
      item.attributes.name.toLowerCase().includes(searchTerm)
    );
    setSearchResults(results);
  }, [searchTerm]);

  return (
    <div>
      <Box mt={2} />
      {error && (
        <Typography variant="h5" component="h2" gutterBottom align="center">
          An error occured please try again
        </Typography>
      )}
      {request ? (
        <Loading />
      ) : (
        <>
        <Grid container>
          <Grid item xs={10}>
          <Box m={5} />
            <Grid container>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="search">Search Products</InputLabel>
                  <Input
                  placeholder="Search for a product..."
                  id="search" 
                  value={searchTerm}
                  onChange={(e) => searchequestChange(e)}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2}>
          <Box m={7} />
            <Button
             component={RouterLink} 
             to={paths.ADD_PRODUCTS_AGENTS} 
             variant="outlined" 
             color="primary"
             className={classes.button}
              startIcon={<AddIcon />} >
              Add Product
            </Button>
            </Grid>
        </Grid>
        <Box m={5} />
          <Grid container spacing={4}>
            {searchResults.length ? (
              searchResults.map((product) => {
                return (
                  <Grid item xs={12} sm={4} key={product.id}>
                    <Card variant="outlined">
                      <Product product={product.attributes} />
                      <CardActions>
                        <Button
                          size="small"
                          color="primary"
                          onClick={handleClickOpen}
                        >
                          Comment
                        </Button>
                      </CardActions>
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="form-dialog-title"
                      >
                        <Comment id={product.id} onclick={handleClose} />
                      </Dialog>
                    </Card>
                  </Grid>
                );
              })
            ) : (
              <Typography
                align="center"
                className={classes.contentWrapper}
                variant="h6"
              >
                No product found
              </Typography>
            )}
          </Grid>
        </>
      )}
    </div>
  );
};

export default GetProducts;
